import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {bzIconCloseCircleOutline, bzIconDispatch, bzIconMenu, bzIconNote} from "@bringoz/ui/icons";
import {ThreePLServiceDetails} from "../../models/threepl-service-details.model";

export interface ServiceActionEvent {
  event: MouseEvent | undefined;
  service: ThreePLServiceDetails;
}

type ServiceAction = "addNote" | "moveToInternal" | "cancel";

require("./threepl-service-actions.scss");

@Component({
  selector: "app-threepl-service-actions",
  templateUrl: "./threepl-service-actions.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServiceActionsComponent {
  readonly service = input.required<ThreePLServiceDetails>();

  readonly addNote = output<ServiceActionEvent>();
  readonly moveToInternal = output<ServiceActionEvent>();
  readonly cancel = output<ServiceActionEvent>();

  readonly icons = {menu: bzIconMenu, addNote: bzIconNote, moveToInternal: bzIconDispatch, cancel: bzIconCloseCircleOutline};
  private lastTriggerClick: MouseEvent | undefined;

  onTriggerClick(event: MouseEvent): void {
    event.stopPropagation();
    this.lastTriggerClick = event;
  }

  onSelected(action: ServiceAction): void {
    const payload: ServiceActionEvent = {event: this.lastTriggerClick, service: this.service()};
    ({addNote: this.addNote, moveToInternal: this.moveToInternal, cancel: this.cancel})[action].emit(payload);
  }
}
